import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class MachineProfile extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/machine?" + queryParam);
    return this._secureFetchWithTimeout(url, "GET", null, 90000); // 1.5 minutes
  }

  listMachineHealth(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/machinehealth?" + queryParam);
    return this._secureFetch(url);
  }

  feedback = (payload) => {
    const url = this._getFullURL(`/machine-health-feedback`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  };

  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getOne(id) {
    const url = this._getFullURL("/machine/" + id);
    return this._secureFetch(url);
  }

  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getThreshold(id, query) {
    //remove key with null value
    Object.keys(query).forEach(
      (key) => query[key] === null && delete query[key]
    );
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/machine/threshold/${id}?${queryParam}`);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getTempThreshold(id, query) {
    //remove key with null value
    Object.keys(query).forEach(
      (key) => query[key] === null && delete query[key]
    );
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(
      `/machine/temperature-threshold/${id}?${queryParam}`
    );
    return this._secureFetch(url);
  }

  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getScheduleByMachine(id) {
    const url = this._getFullURL("/machine/schedules/" + id);
    return this._secureFetch(url);
  }

  /**
   * @description List Machine API function
   * @returns {Promise<Response>}
   */
  listMachineClass() {
    const url = this._getFullURL("/machinetype");
    return this._secureFetch(url);
  }

  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  listMachineArea() {
    const url = this._getFullURL("/room/");
    return this._secureFetch(url);
  }

  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  listDocuments(id) {
    const url = this._getFullURL(`/document/${id}`);
    return this._secureFetch(url);
  }

  /**
   * @description Create Location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload, fileInput) {
    const url = this._getFullURL("/machine");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    fileInput.map((file) => {
      formdata.append("file", file);
    });

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  uploadMachineElement(id,payload, photoFile) {
    const url = this._getFullURL("/machineelement/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    formdata.append("attachments", JSON.stringify(payload));
    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  deleteAttachment(id,attachment) {
    const url = this._getFullURL("/machineelement/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("delete", "1");
    formdata.append("attachment", attachment);
    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  create2(payload, photoFile, machineSpec, productManual, otherDoc) {
    const url = this._getFullURL("/machine");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    formdata.append("machineSpec", machineSpec);
    formdata.append("productManual", productManual);
    formdata.append("otherDoc", otherDoc);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Create Location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  upload(payload, fileInput) {
    const url = this._getFullURL("/machine/upload");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/location/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update Location API function
   * @param {string} id
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  updateStatus = (id, status) => {
    const url = this._getFullURL(`/machine?id=${id}&status=${status}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: {},
        method: "PUT",
      })
    );
  };
  update = (id, payload, fileInput) => {
    const url = this._getFullURL(`/machine/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    fileInput.map((file) => {
      formdata.append("file", file);
    });

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  update2 = (id, payload, photoFile, machineSpec, productManual, otherDoc) => {
    const url = this._getFullURL(`/machine/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    formdata.append("machineSpec", machineSpec);
    formdata.append("productManual", productManual);
    formdata.append("otherDoc", otherDoc);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };
  /**
   * @description Delete machine API function
   * @param {string} uid
   * @returns {Promise<Response>}
   */
  delete = (uid) => {
    const url = this._getFullURL(`/machine/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
  deleteMachineElement = (uid) => {
    const url = this._getFullURL(`/machineelement/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };

  addMachineELement = (payload) => {
    const url = this._getFullURL(`/machineelement`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  };

  updateSchedules = (uid, schedules) => {
    const url = this._getFullURL(`/machine/${uid}/schedule`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("schedules", schedules);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };
  addThreshold = (id, payload) => {
    const url = this._getFullURL(`/machine/threshold/${id}`);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };
  addTemperatureThreshold = (id, payload) => {
    const url = this._getFullURL(`/machine/temperature-threshold/${id}`);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };
}
